import './OfferDetails.less';
import OfferSlider from '../../components/OfferSlider/OfferSlider';
import OfferPerson from '../../components/OfferPerson/OfferPerson';
import OfferInformation from '../../components/OfferInformation/OfferInformation';
import OfferSpecification from '../../components/OfferSpecification/OfferSpecification';
import WhyUs from '../../components/WhyUs/WhyUs';
import Colorbox from '../../components/UI/Colorbox/Colorbox';
// import {tns} from "tiny-slider/src/tiny-slider";
import flexslider from "flexslider/jquery.flexslider-min";
import Sticky from '../../node_modules/sticky-js/src/sticky.js';
import Page from '../../hoc/Page.js';
import {getWindowHeight} from "../../helpers/Helpers";

const OfferDetails = () =>{
	
	if (getWindowHeight() >= 800) {
		
		$(document).ready(function(){
			let sticky = new Sticky('.sticky-js');
		});
		
		window.addEventListener('load', () => {
			let sticky = new Sticky('.sticky-js');
		});
	}
	
	Colorbox($('.colorbox-movie'), {
		width: "100%",
		height: "100%",
		maxHeight: "80%",
		maxWidth: "80%",
		iframe: true
	});
	
	Colorbox($('.slider-colorbox'), {
		width: "100%",
		height: "100%",
		maxHeight: "80%",
		maxWidth: "80%"
	});
	
	const carousel = () => {
		$('#carousel').flexslider({
			animation: "slide",
			controlNav: false,
			animationLoop: false,
			slideshow: false,
			itemWidth: 150,
			itemMargin: 15,
			minItems: 5,
			maxItems: 5,
			asNavFor: '#slider',
			prevText: "",
			nextText: "",
		});
	}

	const slider = () => {
		$('#slider').flexslider({
			animation: "slide",
			controlNav: false,
			animationLoop: false,
			smoothHeight: true,
			slideshow: false,
			sync: "#carousel",
			prevText: "",
			nextText: "",
			// start: function(slider){
			// 	$('body').removeClass('loading');
			// }
		});
	}

	const boot = () => {
		carousel();
		slider();
	};

	boot();
	
	// const slider = tns({
	// 	loop: false,
	// 	container: '.slider__main__box',
	// 	controlsContainer: '.slider__main__controls',
	// 	navContainer: '.slider__thumbnails__images',
	// 	items: 1,
	// 	navAsThumbnails: true,
	// 	mouseDrag: false,
	// 	slideBy: 'page',
	// });
	//
	// const thumbnailsSlider = tns({
	// 	loop: false,
	// 	container: '.slider__thumbnails__images',
	// 	controlsContainer: '.slider__thumbnails__controls',
	// 	items: 5,
	// 	gutter: 0,
	// 	edgePadding: 0,
	// 	mouseDrag: true,
	// 	// nav: false,
	// 	// controls: false,
	// 	slideBy: 'page',
	// 	//axis: "vertical"
	// });
	//
	// let _prev = document.querySelector("[data-controls='prev']");
	// let	_next = document.querySelector("[data-controls='next']");
	// let _prev_slider = document.querySelector("[data-controls='prev-slide']");
	// let	_next_slider = document.querySelector("[data-controls='next-slide']");
	//
	// _prev.addEventListener( 'click', () => {
	// 	thumbnailsSlider.goTo('prev');
	// } );
	// _next.addEventListener( 'click', () => {
	// 	thumbnailsSlider.goTo('next');
	// } );
	//
	// _prev_slider.addEventListener( 'click', () => {
	// 	slider.goTo('prev');
	// } );
	// _next_slider.addEventListener( 'click', () => {
	// 	slider.goTo('next');
	// } );
};

export default Page(OfferDetails);